import type { ShopifyStoreDiscount } from '@discovr/types';
import { shopifyDiscountsCopy as copy } from '@discovr/features/copy';

const percentFmt = new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 });

function money(value: number, currency?: string): string {
  if (currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value);
    } catch {
      // unknown currency code: fall through to the plain number
    }
  }
  return value.toFixed(2);
}

/** "15% off products", "$10.00 off order", "Buy X get Y", "Free shipping"; null when the wire carries nothing to show. */
export function formatDiscountTypeValue(d: ShopifyStoreDiscount): string | null {
  if (d.kind === 'free_shipping') return copy.typeValue.freeShipping;
  if (d.kind === 'bxgy') return copy.typeValue.buyXGetY;
  if (d.value === null || d.value === undefined || !d.value_type) return null;
  const amount =
    d.value_type === 'percentage' ? `${percentFmt.format(d.value)}%` : money(d.value, d.currency);
  const target = d.applies_to === 'products' ? copy.typeValue.products : d.applies_to === 'order' ? copy.typeValue.order : null;
  return target ? copy.typeValue.off(amount, target) : `${amount} off`;
}
